import { render, staticRenderFns } from "./BusSchedule.vue?vue&type=template&id=5e12e6e4&scoped=true"
import script from "./BusSchedule.vue?vue&type=script&lang=js"
export * from "./BusSchedule.vue?vue&type=script&lang=js"
import style0 from "./BusSchedule.vue?vue&type=style&index=0&id=5e12e6e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12e6e4",
  null
  
)

export default component.exports